import { render, staticRenderFns } from "./myOders.vue?vue&type=template&id=68deb6ba"
import script from "./myOders.vue?vue&type=script&lang=js"
export * from "./myOders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports